import { useEffect, useState } from 'react'

interface WindowSize {
  width: number
  height: number
}

import { isMobile, isTablet } from 'react-device-detect'

/**
 * Custom hook to get the window size and update it on width change.
 */

export function useWindowSizeOnWidthChange(): WindowSize {
  const isClient = typeof window === 'object'

  const getSize = (): WindowSize => ({
    width: isClient ? window.innerWidth : 0,
    height: isClient ? window.innerHeight : 0
  })

  const [windowSize, setWindowSize] = useState<WindowSize>(getSize)

  useEffect(() => {
    if (!isClient) return

    let prevWidth = window.innerWidth

    const handleResize = () => {
      const newWidth = window.innerWidth
      const newHeight = window.innerHeight

      if (newWidth !== prevWidth || (!isMobile && !isTablet)) {
        prevWidth = newWidth
        setWindowSize({ width: newWidth, height: newHeight })
      }
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [isClient])

  return windowSize
}
